<template>
  <BTable
    :loading="isLoading"
    :headers="headers"
    :actions="[]"
    :list="data.data"
    v-on="$listeners || {}"
  >
    <template #item.context_from="{ header, item }">
      <span
        v-text="header.getValue(item)"
      />
    </template>

    <template #item.context_to="{ header, item }">
      <span
        v-text="header.getValue(item)"
      />
    </template>

    <template #item.ate_element="{ header, item }">
      <div
        v-html="header.getValue(item)"
      />
    </template>

    <template #item.ate_from="{ header, item }">
      <div
        v-html="header.getValue(item)"
      />
    </template>

    <template #item.ate_to="{ header, item }">
      <div
        v-html="header.getValue(item)"
      />
    </template>
  </BTable>
</template>

<script>
import BTable from '@/components/common/BTable.vue'

import { ATE_HEADERS } from './utils/ate'
import { STATUS_CHANGES_HEADERS } from './utils/statuses'
import { PassportApi } from '@/api/resources/PassportApi'


export default {
  components: {
    BTable,
  },
  props: {
    passportId: {
      type: Number,
      required: true,
    },
    actionTypes: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
    data: {
      data: [],
    },
  }),
  computed: {
    headers() {
      if (this.actionTypes.includes('activate')) {
        return STATUS_CHANGES_HEADERS
      }
      return ATE_HEADERS
    },
  },
  watch: {
    passportId: {
      immediate: true,
      handler() {
        this.onLoadData()
      },
    },
  },
  methods: {
    async onLoadData() {
      this.isLoading = true
      try {
        const api = new PassportApi()
        const { data } = await api.history(this.passportId, {
          action_type: this.actionTypes,
        })
        if (this.actionTypes.includes('activate') || this.actionTypes.includes('status_updated')) {
          this.data.data = data
        } else {
          this.data.data = data.filter((obj) => obj.context && obj.context.to && obj.context.from)
        }
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
